import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { PaymentContext } from "../../context/PaymentContext";
import "./PaymentResult.css";

const PaymentResult = () => {
  const { paymentResult } = useContext(PaymentContext);
  const { status } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  // URL'den tüm parametreleri al
  const urlParams = new URLSearchParams(window.location.search);
  const allParams = Object.fromEntries(urlParams.entries());

  useEffect(() => {
    const handlePaymentResult = async () => {
      if (!allParams || Object.keys(allParams).length === 0) {
        return;
      }

      try {
        const result = await paymentResult(allParams);

        if (status === 'success' && result?.amount) {
          document.cookie = "share_ref=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

          fbq('track', 'Purchase', {
            value: parseFloat(result.amount),
            currency: 'TRY',
            content_ids: result.order_id || '',
            content_type: 'product'
          });
        }
      } catch (error) {
        console.error("Ödeme sonucu işlenirken hata:", error);
        setError("Ödeme sonucu işlenirken bir hata oluştu.");
      }
    };

    handlePaymentResult();
  }, [status, paymentResult]);

  const handleGoHome = () => {
    navigate('/');
  };

  // Hata durumu
  if (error) {
    return (
      <div className="payment-result-wrapper">
        <div className="payment-error-card">
          <div className="error-icon-container">
            <div className="error-icon">⚠️</div>
          </div>
          <h2 className="error-title">Bir Hata Oluştu</h2>
          <p className="error-message">{error}</p>
          <button className="payment-btn payment-btn-error" onClick={handleGoHome}>
            <span className="btn-icon">🏠</span>
            Ana Sayfaya Dön
          </button>
        </div>
      </div>
    );
  }

  // Başarılı ödeme
  if (status === 'success') {
    return (
      <div className="payment-result-wrapper">
        <div className="payment-success-card">
          <div className="success-confetti">
            <span className="confetti-piece">🎉</span>
            <span className="confetti-piece">✨</span>
            <span className="confetti-piece">🎊</span>
            <span className="confetti-piece">✨</span>
            <span className="confetti-piece">🎉</span>
          </div>
          <div className="success-icon-container">
            <div className="success-icon">✓</div>
          </div>
          <h1 className="success-title">Ödeme Başarılı!</h1>
          <p className="success-message">
            Ödemeniz başarıyla tamamlandı.<br />
            Siparişiniz hızlıca hazırlanacaktır.
          </p>
          <div className="success-subtext">Teşekkür ederiz!</div>
          <button className="payment-btn payment-btn-success" onClick={handleGoHome}>
            <span className="btn-icon">🏠</span>
            Ana Sayfaya Dön
          </button>
        </div>
      </div>
    );
  }

  // Başarısız ödeme
  if (status === 'failure') {
    return (
      <div className="payment-result-wrapper">
        <div className="payment-failure-card">
          <div className="failure-icon-container">
            <div className="failure-icon">✗</div>
          </div>
          <h1 className="failure-title">Ödeme Başarısız</h1>
          <p className="failure-message">
            Ödeme işlemi sırasında bir hata oluştu.<br />
            Lütfen tekrar deneyin veya başka bir ödeme yöntemi seçin.
          </p>
          <button className="payment-btn payment-btn-failure" onClick={handleGoHome}>
            <span className="btn-icon">🏠</span>
            Ana Sayfaya Dön
          </button>
        </div>
      </div>
    );
  }
};

export default PaymentResult;